import React, { useEffect, useRef } from 'react';
import useCountries from '@hooks/use-countries/useCountries.tsx';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  dataTestId?: string;
}

const InputCountry: React.FC<ComponentProps> = ({ value, onChange, disabled, dataTestId }) => {
  const countries = useCountries();
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-dropdown', dataTestId);
  }, [countries, dataTestId]);

  return (
    <div ref={wrapperRef} style={{ width: '100%' }}>
      <Dropdown
        options={countries}
        value={value}
        onChange={e => onChange(e.value)}
        optionValue={'code'}
        optionLabel={'name'}
        itemTemplate={(option: { name: string; code: string }) => (
          <span data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option.code)}` : undefined}>
            {option.name}
          </span>
        )}
        style={{ width: '100%', height: '42px' }}
        disabled={disabled}
        filter={true}
        filterBy="name"
        filterMatchMode="contains"
        panelClassName={dataTestId}
      />
    </div>
  );
};

export default InputCountry;
